var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-verify-doc-number-open-text-panel",
      attrs: {
        title: "Comprobar numeración en Librería",
        "ok-title": "Comprobar numeración",
        "hide-footer": ""
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-overlay",
              {
                attrs: {
                  variant: "white",
                  show: _vm.loading,
                  "spinner-variant": "primary",
                  blur: "0",
                  opacity: ".75",
                  rounded: "sm"
                }
              },
              [
                _c("h4", [_vm._v("Listado de versiones encontradas")]),
                _c("div", { staticClass: "alert alert-warning p-3" }, [
                  _c("strong", [_vm._v("IMPORTANTE")]),
                  _vm._v(
                    " La versión numerada se recupera posterior al envío del documento, si solo ves una versión es que aún no se numera "
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "ul",
                    { staticClass: "wrap-versions mt-5 col-12" },
                    _vm._l(_vm.versions, function(version, $index) {
                      return _c(
                        "li",
                        { key: "version-" + $index, staticClass: "version" },
                        [
                          _c(
                            "div",
                            { staticClass: "actions" },
                            [
                              _c("feather-icon", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Ver documento de la versión",
                                    expression: "'Ver documento de la versión'"
                                  }
                                ],
                                attrs: {
                                  size: "18",
                                  icon: "EyeIcon",
                                  color: "green"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.viewVersionDocument(version)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("strong", [_vm._v("Doc Nº:")]),
                          _vm._v(" " + _vm._s(version["DOCNUMBER"]) + " "),
                          _c("br"),
                          _c("strong", [_vm._v("Versión:")]),
                          _vm._v(_vm._s(version["VERSION_ID"]) + " "),
                          _c("span", { staticClass: "float-right" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("timeAgo")(
                                    version["LASTEDITDATE"],
                                    true
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _vm.versions.length > 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: {
                              click: function($event) {
                                return _vm.startApproval()
                              }
                            }
                          },
                          [_vm._v(" Iniciar proceso de aprobación ")]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            on: {
                              click: function($event) {
                                return _vm.startApproval()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " Iniciar proceso de aprobación solo con doc sin numerar "
                            )
                          ]
                        )
                  ])
                ])
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }